import { useState } from "react";
import CustomerAddEdit from "../../Customer/CustomerAddEdit";
import CustomerAddressContainer from "./CustomerAddressContainer";
import CustomerGeneralInfo from "./CustomerGeneralInfo";

export default function CustomerProfile({ data }) {
  const [editType, setEditType] = useState(null);
  const [editItem, setEditItem] = useState(null);

  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
      setEditType(null);
    }
    setModal((prev) => !prev);
  };

  const onEditProfile = (editedProfileData) => {
    setEditType(1);
    setEditItem({ ...editedProfileData, gender: editedProfileData.gender + "" });
    toggle();
  };

  const onEditAddress = (editedAddressData) => {
    setEditType(2);
    setEditItem({
      address: editedAddressData?.editItem ?? {},
      id: editedAddressData?.editItem?.common_id
    });
    toggle();
  };

  const onAddAddress = () => {
    setEditType(2);
    setEditItem({
      address: {},
      id: data?.profile?.id
    });
    toggle();
  };

  return (
    <div className="row g-3">
      <div className="col-12">
        <CustomerGeneralInfo data={data?.profile ?? {}} onEdit={onEditProfile} />
      </div>
      <div className="col-12">
        <CustomerAddressContainer
          data={data?.address ?? []}
          onEdit={onEditAddress}
          onAdd={onAddAddress}
        />
      </div>

      {modal && (
        <CustomerAddEdit modal={modal} toggle={toggle} editItem={editItem} editType={editType} />
      )}
    </div>
  );
}
